<template>
  <div v-if="active" class="dialog-backdrop wrap">
      <div class="dialog-container">
        <div class="message"><slot /></div>
      </div>
    </div>
</template>

<script>
export default {
  name: "BaseDialog",
  props: {
    active: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.dialog-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  flex-direction: column;
  z-index: 99999;
}

.dialog-container {
  max-width: 768px;
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
  background-color: rgba(255, 255, 255, 0);
  border-radius: 5px;
  text-align: center;
  width: 80%;
}

.dialog-enter-active,
.dialog-leave-active {
  transition: opacity 0.2s;
}
.dialog-enter,
.dialog-leave-to {
  opacity: 0;
}

.dialog-enter-active .dialog-container,
.dialog-leave-active .dialog-container {
  transition: transform 0.4s;
}
.dialog-enter .dialog-container,
.dialog-leave-to .dialog-container {
  transform: scale(0.9);
}
.btn-close {
  color: #33a8ee;
  border: none;
  outline: none;
  background: none;
  padding-top: 15px;
}
/*  */

</style>